module.exports = __webpack_public_path__ + "img/icon-avg-consumption.4a905c19.svg";